import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * The only way class names are combined in this app.
 *
 * clsx flattens conditionals; twMerge resolves Tailwind conflicts so a
 * caller's `className` always wins over a component's default. Without the
 * merge, `<Button className="bg-danger">` renders both backgrounds and the
 * winner depends on stylesheet order.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
